import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import useMain from '../../../hooks/useMain';
import { handleCopy } from '../../../utils/helpers';
import Image from './../../common/image';
import WalletRequestModalForm from './walletRequestModalForm';

function WalletRequestModal({ onClose, show, hasSP, isLoading, response, onRequestSubmit }) {
	const { theme } = useMain();
	const [showPK, setShowPK] = useState(false);

	return (
		<Modal
			contentClassName={`bg-${theme}`}
			centered
			show={show}
			onHide={onClose}>
			<Modal.Header
				closeVariant={theme === 'dark' ? 'white' : undefined}
				closeButton>
				<Modal.Title className='d-flex aling-items-center'>
					<Image
						height='40px'
						className='me-2'
						fileName={`logo/icon_${theme}.webp`}
					/>
					<span className='fs-4'>Request Wallet</span>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{!response ? (
					<WalletRequestModalForm
						theme={theme}
						hasSP={hasSP}
						isLoading={isLoading}
						onSubmit={onRequestSubmit}
					/>
				) : (
					<>
						<div className='text-center text-break'>
							<div>
								<span className='fw-bold'>Address:</span> {response.address}
							</div>
							<div className='my-3'>
								<span className='fw-bold'>Private Key:</span>{' '}
								{showPK ? response.pk : '*'.repeat(64)}
							</div>
						</div>
						<div className='d-flex justify-content-evenly align-items-center mt-4'>
							<button
								onClick={() => setShowPK(!showPK)}
								className={`btn btn-set2-${theme}`}>
								{showPK ? 'Hide PK' : 'Show PK'}
							</button>
							<button
								onClick={() => handleCopy(response.pk)}
								className={`btn btn-set2-${theme}`}>
								Copy PK
							</button>
						</div>
					</>
				)}
			</Modal.Body>
		</Modal>
	);
}

export default WalletRequestModal;
